import React, { useState } from "react";
import { intl } from "LocaleWrapper";
import { useMutation } from "@apollo/client";
import { Button, Textarea } from "@cofano/cck";
import { Box } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import LabelSelect, { LabelSelectOption } from "view/labels/components/selects/LabelSelect";
import { CommentableEntity } from "../../utils";
import { Comment } from "types/commons";
import { LabelType } from "__generated__/enums";
import { SaveCommentDocument } from "__generated__/components/comments/graphql/comment.mutations.generated";

interface CommentsWidgetFormProps {
	entity?: CommentableEntity;
	onSave: (comment: Comment) => void;
}

const CommentsWidgetForm = ({ entity, onSave }: CommentsWidgetFormProps) => {

	const [ currentComment, setCurrentComment ] = useState("");
	const [ selectedLabel, selectLabel ] = useState<LabelSelectOption | undefined>();

	const [ saveComment, { loading } ] = useMutation(SaveCommentDocument);

	const save = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {

		if (event.shiftKey || !entity) {
			return;
		}

		saveComment({
			variables: {
				input: {
					comment: currentComment.trim(),
					labelId: selectedLabel?.id,
					entityId: entity.id,
					entityType: entity.type,
				},
			},
		}).then(response => {

			const comment = response.data?.saveComment as Comment;

			setCurrentComment("");
			selectLabel(undefined);

			onSave(comment);
		});
	};

	return (
		<Box sx={{ display: "flex", flexBasis: "15%" }}>
			<Box sx={{ flexGrow: 1, pr: 2 }}>
				<Box sx={{ mb: 0.5 }}>
					<Textarea
						disabled={!entity?.id}
						value={currentComment}
						onChange={event => setCurrentComment(event.target.value)}
						style={{ padding: 4, resize: "none" }} />
				</Box>

				<LabelSelect
					disabled={!entity?.id}
					value={selectedLabel}
					onChange={option => selectLabel(option || undefined)}
					placeholder={intl.formatMessage({ id: "LABEL_SELECT" })}
					type={LabelType.Comment} />
			</Box>

			<Box sx={{ alignItems: "center", display: "flex" }}>
				<Button
					icon={<SendIcon />}
					disabled={!currentComment.trim() || !entity?.id || loading}
					onClick={(event) => save(event)}
					loading={loading} />
			</Box>
		</Box>
	);
};

export default CommentsWidgetForm;
